<template>
  <div class="ui active inverted dimmer" ref="spinny" v-show="working">
    <div class="ui text loader" v-if="working">
      <span v-if="showText">{{ $t('LOADING') }}</span>
    </div>
    <div class="ui error message" v-if="showError && err">
      {{ err }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '~scss/variables';
</style>

<script>
// @flow
import Vue from 'vue'
import { Observable } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { ActionTypes } from 'store'

/**
 * A simple loader / spinner component that takes in a Promise as a prop and renders a loader while the Promise is resolving.
 *
 * i.e. <Spinny :promise="Promise"/>
 */
export default {
  name: 'spinny',

  data() {
    return {
      working: false,
      showText: true,
      err: '',
      spinner: null
    }
  },

  props: {
    observable: Observable,
    promise: null,
    showError: {
      type: Boolean,
      default: () => false
    },
    message: {
      type: String,
      default: () => ''
    }
  },

  methods: {
    // Throttle spinner by 200ms; disable text under 200px in size
    createNewSpinner() {
      return setTimeout(() => {
        this.working = true

        Vue.nextTick(() => {
          if (this.$refs.spinny && this.$refs.spinny.clientWidth > 200) {
            this.showText = true
          } else {
            this.showText = false
          }
        })
      }, 200)
    },
    removeSpinner() {
      this.working = false
      clearTimeout(this.spinner)
    },

    handleNewPromise() {
      if (this.spinner) {
        this.removeSpinner()
      }
      this.spinner = this.createNewSpinner()

      const promise = this.observable
        ? this.observable.toPromise()
        : this.promise || Promise.resolve()

      if (this.message)
        this.$store.dispatch(ActionTypes.REGISTER_TASK, {
          task: { description: this.message },
          promise
        })
      promise
        .then(() => {
          this.removeSpinner()
        })
        .catch(err => {
          this.err = err
          this.removeSpinner()
        })
    }
  },

  created() {
    this.handleNewPromise()
  },

  watch: {
    observable: {
      handler() {
        this.handleNewPromise()
      },
      deep: true
    },
    promise: {
      handler() {
        this.handleNewPromise()
      },
      deep: true
    }
  }
}
</script>
